module.exports = __webpack_public_path__ + "img/selected4-min.eb0f50aa.png";